import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { Button, Col, Divider, Form, Input, Modal, Row, message } from "antd";
import * as API from "common/api";
import * as COMMONS from "common/common";
import "moment/dist/locale/ja";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const UpdateCountRegistrationModal = ({ isOpen, onCancel, registration }) => {
	const navigate = useNavigate();

	const [updateParticipationForm] = Form.useForm();

	useEffect(() => {
		updateParticipationForm.setFieldsValue({
			displayName: registration?.Member?.displayName,
			participantCount: registration?.participantCount,
			companionCount: registration?.companionCount,
		});
	}, [registration, updateParticipationForm]);

	const masterUpdateCountRegistrationMutation = useMutation(
		[
			API.MUTATION_KEY_MASTER_UPDATE_COUNT_REGISTRATION,
			registration?.registrationId,
		],
		async (data) => {
			try {
				await API.masterUpdateCountRegistration({
					...data,
				});
				message.success(COMMONS.SUCCESS_UPDATE_MSG);
			} catch (error) {
				if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
					navigate(COMMONS.PERMISSION_ERROR_ROUTE);
				} else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
					message.warning({
						content: COMMONS.ERROR_SESSION_MSG,
						key: COMMONS.MESSAGE_SESSION_ERROR_KEY,
					});
					navigate(COMMONS.ADMIN_LOGIN_ROUTE);
				} else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
					message.error({
						content: COMMONS.ERROR_SYSTEM_MSG,
						key: COMMONS.MESSAGE_SYSTEM_ERROR_KEY,
					});
				} else {
					message.error({
						content: COMMONS.ERROR_SYSTEM_MSG,
						key: COMMONS.MESSAGE_SYSTEM_ERROR_KEY,
					});
				}
			}
		},
	);
	const handleUpdateCountRegistration = (values) => {
		if (!registration?.registrationId) return;
		masterUpdateCountRegistrationMutation.mutate({
			registrationId: registration?.registrationId,
			...values,
		});
		onCancel();
	};

	return (
		<Modal
			open={isOpen}
			title="予約変更"
			onCancel={onCancel}
			footer={null}
			centered
			destroyOnClose={true}
			afterClose={updateParticipationForm.resetFields}
		>
			<div className="p-2">
				<Form
					form={updateParticipationForm}
					preserve={false}
					layout="vertical"
					initialValues={{
						displayName: "",
						participantCount: 0,
						companionCount: 0,
					}}
					onFinish={handleUpdateCountRegistration}
				>
					<Row justify="center">
						<Col xs={24}>
							<Form.Item name="displayName" label="名前">
								<Input disabled={true} />
							</Form.Item>
						</Col>
					</Row>
					<Divider />
					<Row justify="center">
						<Col span={24} className="text-center">
							<Form.Item label={"参加者"} className="block">
								<Input.Group compact>
									<Button
										icon={<MinusOutlined />}
										style={{ marginRight: 0 }}
										onClick={() => {
											if (
												updateParticipationForm.getFieldValue(
													"participantCount",
												) > 0
											) {
												updateParticipationForm.setFieldsValue({
													participantCount:
														updateParticipationForm.getFieldValue(
															"participantCount",
														) - 1,
												});
											}
										}}
									/>
									<Form.Item
										name="participantCount"
										rules={[
											{
												required: true,
												message: `参加者の数は必須です`,
											},
										]}
										noStyle
									>
										<Input
											style={{
												width: "80px",
												borderLeftWidth: 0,
												borderRightWidth: 0,
												textAlign: "center",
											}}
											readOnly
											tabIndex="-1"
										/>
									</Form.Item>
									<Button
										icon={<PlusOutlined />}
										onClick={() => {
											updateParticipationForm.setFieldsValue({
												participantCount:
													updateParticipationForm.getFieldValue(
														"participantCount",
													) + 1,
											});
										}}
									/>
								</Input.Group>
							</Form.Item>
						</Col>

						<Col span={24} className="text-center">
							<Form.Item label={"同伴者"} className="block">
								<Input.Group compact>
									<Button
										icon={<MinusOutlined />}
										style={{ marginRight: 0 }}
										onClick={() => {
											if (
												updateParticipationForm.getFieldValue(
													"companionCount",
												) > 0
											) {
												updateParticipationForm.setFieldsValue({
													companionCount:
														updateParticipationForm.getFieldValue(
															"companionCount",
														) - 1,
												});
											}
										}}
									/>
									<Form.Item
										name="companionCount"
										rules={[
											{
												required: true,
												message: `同伴者の数は必須です`,
											},
										]}
										noStyle
									>
										<Input
											style={{
												width: "80px",
												borderLeftWidth: 0,
												borderRightWidth: 0,
												textAlign: "center",
											}}
											readOnly
											tabIndex="-1"
										/>
									</Form.Item>
									<Button
										icon={<PlusOutlined />}
										onClick={() => {
											updateParticipationForm.setFieldsValue({
												companionCount:
													updateParticipationForm.getFieldValue(
														"companionCount",
													) + 1,
											});
										}}
									/>
								</Input.Group>
							</Form.Item>
						</Col>
						<Col span={24}>
							<Row gutter={[8, 8]} justify="center" className="m-4">
								<Col>
									<Button onClick={onCancel}>閉じる</Button>
								</Col>
								<Col>
									<Button
										type="primary"
										htmlType="submit"
										loading={masterUpdateCountRegistrationMutation.isLoading}
									>
										変更
									</Button>
								</Col>
							</Row>
						</Col>
					</Row>
				</Form>
			</div>
		</Modal>
	);
};

export default UpdateCountRegistrationModal;
